import Card, { CardHeader } from '../../components/ui/Card';
import UuidActionForm from '../../components/admin/UuidActionForm';
import { useUnlockUserMutation } from '../../features/admin/adminAccountsApi';

/**
 * POST /admin/users/{uuid}/unlock, available to both admin and super-admin
 * (unlike the rest of the Admin tag, which needs the super-admin-only
 * manage-admins permission). Per the docs, permission depends on the
 * *target's* role, not the caller's: an admin can unlock an investor
 * (manage-investors) but not another admin (manage-admins) — super-admin
 * can unlock anyone. The API returns the same 403 either way if the
 * caller lacks the right permission for that particular target, so this
 * page is intentionally simple and lets the server be the source of truth
 * on who's allowed to unlock whom.
 *
 * Search-by-email works for admin targets, since GET /admin/admins is the
 * only real endpoint anywhere that returns {email, uuid} pairs. There's no
 * equivalent endpoint yet for investor accounts (Investors is still "not
 * yet populated"), so those still need the manual-UUID fallback built
 * into UuidActionForm.
 */
export default function UnlockAccount() {
  const [unlockUser, { isLoading }] = useUnlockUserMutation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Unlock account</h1>
        <p className="text-foreground-muted text-sm mt-1">
          Clear a lockout caused by repeated failed login attempts.
        </p>
      </div>

      <Card className="max-w-md">
        <CardHeader title="Unlock account" />
        <UuidActionForm
          actionLabel="Unlock account"
          helperText="Search finds admin accounts by email. Investor accounts aren't searchable yet — use the manual UUID option for those."
          onRun={unlockUser}
          isLoading={isLoading}
          successMessage="Account unlocked."
          notFoundMessage="No account exists with that UUID."
          lookup="admins"
        />
      </Card>
    </div>
  );
}
